export const trimCharRight = (str: string, char: string): string => {
    const regex = new RegExp(`${char}+$`, 'gi');
    return str.replace(regex, '');
};

export const titleCase = (str: string): string => {
    str = str.toLowerCase();
    const words = str.split(' ');

    const capitalized = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.substring(1, word.length);
    });
    return capitalized.join(' ');
};
